import React from "react";
import {Route} from "react-router-dom";
import ChangePasswordContainer from "../../pages/changePassword";
import {CHANGE_PASSWORD_ROUTE, MFA_MANUAL_ROUTE, MFA_ROUTE} from "../../utils/constants/RoutesConstants";
import MFAContainer from "../../pages/mfa";
import MFAManual from "../../pages/mfa/Manual2FA";

const UserRoutes = () => {
    return (
        <React.Fragment>
            <Route path={CHANGE_PASSWORD_ROUTE} component={ChangePasswordContainer}/>
            <Route path={MFA_ROUTE} component={MFAContainer}/>
            <Route path={MFA_MANUAL_ROUTE} component={MFAManual}/>
        </React.Fragment>
    );
};

export default UserRoutes;